import { PoiDetails } from './Detail';
import { Brands } from './Brands';
import { Brand } from './Brand';
import { NewBrand } from './NewBrand';

export const poi = {
  routes: [{
    component: PoiDetails,
    path: '/',
    exact: true,
  },
  {
    component: Brands,
    path: '/brands',
    exact: true,
  },
  {
    component: Brand,
    path: '/brand/:brandId',
    exact: true,
  },
  {
    component: NewBrand,
    path: '/brand',
    exact: true,
  },
  ],
};
